module.exports = __webpack_public_path__ + "media/images/landing_page/home_main-7a13ee4827bbcb64bb6bcce6078b6cb5.webp";